import * as $ from 'jquery';
import memoizeOne from 'memoize-one';
import 'print-this';
import { dayEnd, dayStart, rusDateTime } from 'webui/utils/time';
import { async_select_tracking_viewport_stats } from 'entities/device.map.track/lib/selectors';
import { loadTrack } from 'entities/device.map.track/model/actions';
import { any2unix } from 'webui/utils/unixtime';
export class GraphBlockSet {
    _ui;
    loader_provider;
    _element;
    _graph_blocks;
    _period;
    _loaders;
    _wheel_zoom;
    _wheel_zoom_all;
    cacheCombinedData;
    period = (value) => {
        if (value)
            this._period = value;
        return this._period;
    };
    constructor(loader_provider, ui) {
        this._ui = ui;
        this.loader_provider = loader_provider;
        this._element = $('<div class="ui-graphs-container ui-cards-container"></div>');
        this._graph_blocks = [];
        const now = new Date();
        this._period = [dayStart(now), dayEnd(now)];
        this._loaders = {};
        this._wheel_zoom_all = true;
        this.cacheCombinedData = memoizeOne((combined) => combined, (a, b) => {
            let all_equal = true;
            for (const [key, data] of Object.entries(a ?? {})) {
                if (b[key] !== data) {
                    all_equal = false;
                    break;
                }
            }
            if (all_equal) {
                for (const [key, data] of Object.entries(b ?? {})) {
                    if (a[key] !== data) {
                        all_equal = false;
                        break;
                    }
                }
            }
            if (all_equal)
                console.log('saved redraw!');
            return all_equal;
        });
    }
    destroy = () => {
        for (const block of this._graph_blocks) {
            block.destroy();
        }
        this._graph_blocks = [];
        this._update_loaders();
        this._element.remove();
    };
    element = () => this._element;
    clear = () => {
        for (const block of this._graph_blocks)
            block.destroy();
        this._graph_blocks = [];
    };
    wheel_zoom = () => this._wheel_zoom;
    set_wheel_zoom = (value) => {
        this._wheel_zoom = value;
        for (const block of this._graph_blocks) {
            block.set_wheel_zoom(value);
        }
    };
    wheel_zoom_all = () => this._wheel_zoom_all;
    set_wheel_zoom_all = (value) => (this._wheel_zoom_all = value);
    view_port_change_all = (value, no_event) => {
        for (const block of this._graph_blocks) {
            block.set_viewport(value, no_event);
        }
    };
    view_port_change_one = (value, position, no_event) => {
        for (const block of this._graph_blocks) {
            const block_offset = block._element.offset();
            const block_offset_height = block._element.get(0)?.offsetHeight;
            if (block_offset && block_offset_height && position) {
                if (block_offset.top <= position.pageY &&
                    block_offset.top + block_offset_height >= position.pageY) {
                    block.set_viewport(value, no_event);
                }
            }
        }
    };
    view_port_change = (value, position, no_event) => {
        if (this._wheel_zoom_all) {
            this.view_port_change_all(value, no_event);
        }
        else {
            this.view_port_change_one(value, position, no_event);
        }
    };
    hover = (time, position) => {
        for (const other of this._graph_blocks) {
            other.hover(time, position);
        }
        for (const b of this._graph_blocks) {
            b.show_legend_values_for(time);
        }
    };
    unhover = () => {
        for (const other of this._graph_blocks) {
            other.clear_crosshair();
            other.interaction_start();
        }
        for (const b of this._graph_blocks)
            b.show_legend_values();
    };
    add_block = (block, index = null) => {
        block.set_wheel_zoom(this.wheel_zoom());
        block._element.attr('id', index);
        for (const other of this._graph_blocks)
            if (other !== block) {
                const viewport = block.get_viewport();
                if (viewport)
                    other.set_viewport(viewport);
            }
        if (index == null) {
            index = this._graph_blocks.length;
        }
        this._graph_blocks.splice(index, 0, block);
        const children = this._element.children();
        if (children.length === 0)
            this._element.append(block.element());
        else if (index === 0)
            this._element.prepend(block.element());
        else
            children.eq(index - 1).after(block.element());
    };
    full_screen_block_resize = () => {
        for (const block of this._graph_blocks) {
            if (block.full_screen()) {
                block.resize();
            }
        }
    };
    header_print = async () => {
        const now = new Date();
        const [mintime, maxtime] = this.period();
        const device = this._ui.devices.selectedDevice();
        let promise = async_select_tracking_viewport_stats(this._ui.store.getState(), device.id(), this._ui.api);
        if (!promise) {
            await this._ui.store.dispatch(
            //@ts-ignore
            loadTrack(device.id(), any2unix(mintime), any2unix(maxtime)));
            promise = async_select_tracking_viewport_stats(this._ui.store.getState(), device.id(), this._ui.api);
        }
        return `<p>Название: ${device.name() ?? 'Нет данных'}
               <p>Период: с ${rusDateTime(mintime)} по ${rusDateTime(maxtime)}
               <p>Дата печати ${rusDateTime(now)}`;
    };
    print_graphs = async (block = null, header = this.header_print()) => {
        const result_header = await header;
        try {
            await new Promise((resolve, reject) => {
                (block?.element() ?? this.element()).printThis({
                    importStyle: true,
                    canvas: true,
                    header: result_header,
                    // debug: true,
                    beforePrint: () => {
                        for (const block of this._graph_blocks) {
                            block._graph._plotElement.width(1024 - 40);
                            block._graph.redraw();
                        }
                    },
                    afterPrint: () => {
                        for (const block of this._graph_blocks) {
                            block._graph._plotElement.width('');
                            block._graph.redraw();
                        }
                        resolve();
                    },
                });
            });
        }
        catch (error) {
            console.log('ERROR', error);
            throw error;
        }
    };
    replace_block = (old_block, new_block) => {
        const index = this._graph_blocks.indexOf(old_block);
        if (index === -1)
            return;
        this._graph_blocks.splice(index, 1);
        this.add_block(new_block, index);
        old_block.destroy();
        this._align_graphs();
        this.reload();
    };
    delete_block = (block) => {
        const index = this._graph_blocks.indexOf(block);
        if (index === -1)
            return;
        this._graph_blocks.splice(index, 1);
        block.destroy();
        this._align_graphs();
        this._update_loaders();
    };
    _align_graphs = () => {
        const max_yaxes_width = Math.max(...this._graph_blocks.map((block) => block.yaxes_width()));
        for (const block of this._graph_blocks) {
            block.set_yaxes_full_width(max_yaxes_width);
            block.redraw();
        }
    };
    redraw = () => this._redraw_all();
    _update_loaders = () => {
        const required_keys = {};
        for (const block of this._graph_blocks)
            for (const source of block.sources())
                required_keys[source.data_source_key()] = true;
        const to_delete = Object.keys(this._loaders).filter((key) => !required_keys[key]);
        for (const key of to_delete) {
            this._loaders[key].unbind_updates();
            delete this._loaders[key];
        }
        const to_add = Object.keys(required_keys).filter((key) => !this._loaders[key]);
        for (const key of to_add) {
            const loader = this.loader_provider.get_loader(key);
            if (loader == null) {
                console.error('Unknown loader key:', key);
                continue;
            }
            loader.bind_updates((mintime, maxtime, data) => this._redraw_all());
            this._loaders[key] = loader;
        }
    };
    _redraw_all = () => {
        const all_data = {};
        for (const [key, loader] of Object.entries(this._loaders ?? {}))
            all_data[key] = loader.data();
        const data = this.cacheCombinedData(all_data);
        for (const block of this._graph_blocks)
            block.replace_data(data);
    };
    reload = () => {
        return new Promise((resolve, reject) => {
            for (const block of this._graph_blocks)
                block.loading(true);
            this._update_loaders();
            const keys2blocks = {};
            for (const block of this._graph_blocks)
                for (const key of block.data_source_keys())
                    if (keys2blocks[key])
                        keys2blocks[key].push(block);
                    else
                        keys2blocks[key] = [block];
            const [mintime, maxtime] = this.period();
            const data = {};
            const pending_blocks = this._graph_blocks.slice();
            const block_ready = function (block) {
                for (const key of block.data_source_keys())
                    if (!(key in data))
                        return false;
                return true;
            };
            const check_ready = () => {
                let i = 0;
                while (i < pending_blocks.length) {
                    const block = pending_blocks[i];
                    if (block_ready(block)) {
                        block.set_data([mintime, maxtime], data);
                        block.loading(false);
                        pending_blocks.splice(i, 1);
                    }
                    else
                        i++;
                }
                if (pending_blocks.length === 0)
                    this._align_graphs();
            };
            for (const [loader_key, loader] of Object.entries(this._loaders ?? {})) {
                loader
                    .load(~~(mintime.getTime() / 1e3), ~~(maxtime.getTime() / 1e3))
                    .then((loader_data) => {
                    data[loader_key] = loader_data;
                    check_ready();
                });
            }
            check_ready();
            resolve();
        });
    };
    serialize = () => this._graph_blocks.map((block) => block.serialize());
}
